import wx from 'weixin-js-sdk';
import axios from 'axios';
import store from '@/vuex/store.js';

// axios.defaults.withCredentials = store.state.withCredentials;
// axios.defaults.headers = {
//     'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
// }
// axios.defaults.baseURL = store.state.BASE_URL;
// axios.defaults.timeout = 25000;

const is_wx = () => {
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
};

const wxInit = (debug, appid, timestamp, nonceStr, signature) => {
    wx.config({
        debug: debug,
        appId: appid,
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline','showAllNonBaseMenuItem','showOptionMenu']
        // jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline','showAllNonBaseMenuItem']

        // jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'showAllNonBaseMenuItem']
    });
}

/**
 * 
 * 
 * @param {String} title 分享标题
 * @param {String} desc 分享描述
 * @param {String} url 分享点击之后的链接
 * @param {String} imgUrl 分享图标
 * @param {string} [music、video或link，不填默认为link] 
 */
const wxReWriteShare = (title, desc, url, imgUrl, type = 'link') => {
    console.log(store.state.url);
    axios.get(`/api/share/getconfig`, {
        params: {
            // 判断是否是ios微信浏览器 
            urll: window.__wxjs_is_wkwebview === true ? encodeURIComponent(store.state.url.split('#')[0]) : encodeURIComponent(window.location.href.split('#')[0])
        }
    }).then((res) => {
        wxInit(false, res.data.appId, res.data.timestamp, res.data.nonceStr, res.data.signature);
        
        wx.ready(function () {
            
            // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
            console.log("wx.ready")
            console.log(title)
            console.log(desc)
            console.log(url)
            console.log(imgUrl)
            console.log(type)
            //分享给好友
            wx.onMenuShareAppMessage({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: url, // 分享点击之后的链接
                imgUrl: imgUrl, // 分享图标
                type: type, // 分享类型,music、video或link，不填默认为link
                success: function () {
                    // alert(`分享成功`);
                },
                cancel:function() {
                    // 用户取消分享后执行的回调函数
                }
            });

            //分享给朋友圈
            wx.onMenuShareTimeline({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: url, //分享点击之后的链接
                imgUrl: imgUrl, // 分享图标
                type: type, // 分享类型,music、video或link，不填默认为link
                success: function () {
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
            // wx.showOptionMenu();
            //分享到qq
            // wx.onMenuShareQQ({
            //     title: title, // 分享标题
            //     desc: desc, // 分享描述
            //     link: url, // 分享链接
            //     imgUrl: imgUrl, // 分享图标
            //     success: function () {
            //         // 用户确认分享后执行的回调函数
            //         alert("分享成功");
            //     },
            //     cancel: function () {
            //         // 用户取消分享后执行的回调函数
            //     }
            // });

            //分享到微博
            // wx.onMenuShareWeibo({
            //     title: title, // 分享标题
            //     desc: desc, // 分享描述
            //     link: url, // 分享链接
            //     imgUrl: imgUrl, // 分享图标
            //     success: function () {
            //         // 用户确认分享后执行的回调函数
            //         alert("分享成功");
            //     },
            //     cancel: function () {
            //         // 用户取消分享后执行的回调函数
            //     }
            // });

            //分享到QQ空间
            // wx.onMenuShareQZone({
            //     title: title, // 分享标题
            //     desc: desc, // 分享描述
            //     link: url, // 分享链接
            //     imgUrl: imgUrl, // 分享图标
            //     success: function () {
            //         // 用户确认分享后执行的回调函数
            //         alert("分享成功");
            //     },
            //     cancel: function () {
            //         // 用户取消分享后执行的回调函数
            //     }
            // });
        });

        wx.error(function (err) {
            //打印错误消息。及把 debug:false,设置为debug:ture就可以直接在网页上看到弹出的错误提示
            console.log("wx.error(function (err) ")
            console.log(err)
        });

    }).catch((err) => {
        console.log("wx.ready ")
        console.log(err);
    });
};

const openShareList = () => {
    wx.showAllNonBaseMenuItem();
}

export default {
    wx,
    is_wx,
    wxReWriteShare,
    openShareList
}


// WEBPACK FOOTER //
// ./src/common/wx_share.js